const TIMEOUTS = {
  SEND_MESSAGE_UNDO_TIMEOUT: 5000,
  SEARCH_DEBOUNCE_TIMEOUT: 2000,
  SEND_SURVEY_UNDO_TIMEOUT: 5000,
  CUSTOM_OPTION_TIMEOUT: 6000,
  AUTH_VERIFICATION_EXPIRY: '48 hours',
};

export default TIMEOUTS;
